module.exports = __webpack_public_path__ + "ahrefs-wordmark-fc4691403fc20e882e3677776a00d151.webp";